import React, { useState, useEffect } from 'react';
import { getDetalles } from '../services/api';
import { Link } from 'react-router-dom';

const DetallesPerfil = () => {
    const [detalles, setDetalles] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDetalles = async () => {
            try {
                const res = await getDetalles();
                setDetalles(res?.data ?? null);
            } catch (err) {
                console.error('Error al obtener detalles del perfil del usuario:', err);
                setError('Error al obtener los detalles del perfil');
            } finally {
                setLoading(false);
            }
        };
        fetchDetalles();
    }, []);

    if (loading) return <p> Cargando... </p>;
    if (error) return <p className='required-text'>{error}</p>;
    if (!detalles) return <p>No se encontraron los datos del perfil</p>

    const safeField = (value, fallback = '-') => value ?? fallback;
    const renderDetalles = () => {
        switch (detalles.tipo) {
            case "usuario":
                return (
                    <div>
                        <h2> Usuario </h2>
                        <p><strong>Email: </strong>{detalles.email}</p>
                        <p><strong>Permiso: </strong>{detalles.permiso}</p>
                    </div>
                );
            case "paciente":
                return (
                    <div>
                        <h2> Paciente </h2>
                        <p><strong>RUT: </strong>{detalles.rut}</p>
                        <p><strong>Nombre: </strong>{detalles.nombre}</p>
                        <p><strong>Apellido paterno: </strong>{safeField(detalles.apellido_p)}</p>
                        <p><strong>Apellido materno: </strong>{safeField(detalles.apellido_m)}</p>
                        <p><strong>Email: </strong>{detalles.email}</p>
                        <p><strong>Dirección: </strong>{safeField(detalles.direccion)}</p>
                        <p><strong>Teléfono: </strong>{safeField(detalles.telefono)}</p>
                        <p><strong>Fecha de nacimiento: </strong>{safeField(detalles.fecha_nac)}</p>
                        <p><strong>Sexo: </strong>{safeField(detalles.sexo)}</p>
                        <p><strong>Género: </strong>{safeField(detalles.genero)}</p>
                    </div>
                );
            case "empresa":
                return (
                    <div>
                        <h2> Empresa </h2>
                        <p><strong>RUT:</strong>{detalles.rut}</p>
                        <p><strong>Nombre legal:</strong>{detalles.nombre_legal}</p>
                        <p><strong>Ciudad:</strong>{safeField(detalles.ciudad)}</p>
                        <p><strong>Giro:</strong>{safeField(detalles.giro)}</p>
                        <p><strong>Razón social:</strong>{detalles.razon_social}</p>
                        <p><strong>Rubro:</strong>{safeField(detalles.rubro)}</p>
                        <p><strong>Dirección:</strong>{safeField(detalles.direccion)}</p>
                        <p><strong>Forma de pago:</strong>{safeField(detalles.forma_pago)}</p>
                        <p><strong>Dias de pago:</strong>{safeField(detalles.dias_pago)}</p>
                    </div>
                );
            default:
                return <p> Tipo de usuario no soportado</p>;
        }
    }

    return (
        <div className='container-wrapper'>
            <h1> Detalles del Perfil </h1>
            {renderDetalles()}
            {/* Los pacientes no pueden autogestionar su contraseña: deben pedirselo a un administrador */}
            {detalles.tipo !== 'paciente' && (
                <Link to="/perfil/detalles/password" className="btn-edit-profile">
                    Cambiar Contraseña
                </Link>
            )}
        </div>
    )
};
export default DetallesPerfil;